import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

const mapDispatchToProps = dispatch => ({

});

const AUTO_LOGOUT_TIME = 20 * 1000; // 20 seconds
const POPUP_TIMEOUT = 15* 60 * 1000; // 15 minutes

const events = ["mousemove", "keydown", "click", "scroll"];

class SessionTimeout extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false,
            path: null
        }
        this.logoutTimer = null;
        this.popupTimer = null;
    }

    handleDirection = (path) => {
        this.setState({ path })
    }

    componentDidMount() {
        this.resetTimer()
        events.forEach((event) => window.addEventListener(event, this.handleUserActivity));
    }

    componentWillUnmount() {
        if (this.logoutTimer) clearTimeout(this.logoutTimer);
        if (this.popupTimer) clearTimeout(this.popupTimer);
        const events = ["mousemove", "keydown", "click", "scroll"];
        events.forEach((event) => window.removeEventListener(event, this.handleUserActivity));
    }
    resetTimer = () => {
        if (this.logoutTimer) clearTimeout(this.logoutTimer);
        if (this.popupTimer) clearTimeout(this.popupTimer);

        this.popupTimer = setTimeout(() => {
            this.setState({ showPopup: true });
            this.logoutTimer = setTimeout(this.logout, AUTO_LOGOUT_TIME);
        }, POPUP_TIMEOUT);
    };

    stayLoggedIn = () => {
        this.setState({ showPopup: false })
        this.resetTimer();
    }

    logout = () => {
        this.props.handleLogout()
    };

    handleUserActivity = () => {
        if (this.state.showPopup) {
            return;
        }
        this.resetTimer();
    };
    render() {
        return <Fragment>
            {this.state.showPopup ?
                <div className="session-time-out">
                    <div className="alert-time">
                        <p>You have been inactive for a while. Do you want to stay logged in?</p>
                        <div className="time-out-button" onClick={this.stayLoggedIn}> <Button>Yes, Keep Me Logged In</Button> </div>
                    </div>
                </div> : null
            }

        </Fragment>
    }
}

SessionTimeout.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeout);
